export const getHyphenSeparatedString = str => {
    return str?.toLowerCase()?.split(' ').join('-');
}

export const getUnderScoreSepratedString = str => {
    return typeof str == 'string' ? str?.toLowerCase()?.split(" ")?.join("_") : str?.toString()?.toLowerCase()?.split(" ")?.join("_")
}